
export const ROUTES = {
    HOME: '/',

    DASHBOARD: '/dashboard',
    LOGIN: '/login',
    REGISTER: '/register',
  };
  
  export const NAV_ITEMS = [
    { name: 'Features', href: '#features' },
    { name: 'Pricing', href: '#pricing' },

  ];